import { Toggle } from '@/components/Toggle';

interface FeatureFlagRowProps {
    label: string;
    description: string;
    checked: boolean;
    disabled: boolean;
    onCheckedChange: (checked: boolean) => void;
}

export function FeatureFlagRow({
    label,
    description,
    checked,
    disabled,
    onCheckedChange,
}: FeatureFlagRowProps) {
    return (
        <div className="border border-grey-600 rounded-[10px] p-4 flex items-center justify-between">
            <div className="flex flex-col gap-1">
                <span className="text-sm text-grey-200">{label}</span>
                <span className="text-xs text-grey-300">{description}</span>
            </div>
            <Toggle
                checked={checked}
                disabled={disabled}
                onCheckedChange={onCheckedChange}
            />
        </div>
    );
}
